// Country flag emoji utility
export const getCountryFlag = (countryCode: string): string => {
  const countryFlags: { [key: string]: string } = {
    'UK': '🇬🇧',
    'NL': '🇳🇱',
    'DE': '🇩🇪',
    'FR': '🇫🇷',
    'BR': '🇧🇷',
    'FI': '🇫🇮',
    'SE': '🇸🇪',
    'IT': '🇮🇹',
    'JP': '🇯🇵',
    'ES': '🇪🇸',
    'US': '🇺🇸',
    'CA': '🇨🇦',
    'AU': '🇦🇺',
    'NO': '🇳🇴',
    'KR': '🇰🇷',
    'DK': '🇩🇰',
    'RU': '🇷🇺',
    'CN': '🇨🇳',
  };

  return countryFlags[countryCode.toUpperCase()] || '🌍';
};

// Remove https:// prefix from URL
export const formatDomainName = (url: string): string => {
  return url.replace(/^https?:\/\//, '');
};

// Remove www. prefix from URL (after removing protocol)
export const cleanUrl = (url: string): string => {
  return url.replace(/^https?:\/\//, '').replace(/^www\./, '');
};

// Predefined website order
export const websiteOrder = [
  'newyork.co.uk',
  'newyork.nl',
  'newyorkcity.de',
  'newyorkcity.fr',
  'visitenovayork.com.br',
  'newyork.fi',
  'newyork.se',
  'newyorkcity.it',
  'newyork.jp',
  'nuevayork.es',
  'nuevayork.com',
  'newyorkcity.ca',
  'newyork.com.au',
  'newyork.no',
  'newyork.kr',
  'newyorkcity.dk',
  'newyorkcity.ru',
  'newyork.cn',
];

// Sort websites according to predefined order
export const sortWebsitesByOrder = <T extends { website_id: string }>(websites: T[]): T[] => {
  return [...websites].sort((a, b) => {
    const indexA = websiteOrder.indexOf(a.website_id);
    const indexB = websiteOrder.indexOf(b.website_id);
    
    // If both are in the order list, sort by their position
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    
    // If only one is in the order list, it comes first
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    
    // If neither is in the order list, sort alphabetically
    return a.website_id.localeCompare(b.website_id);
  });
};